<div class="order-item-compact">
  <inventory-ui-item-label
    [item]="{
      itemId: item.id,
      name: item.name,
      iconUrl: item.iconUrl,
      subtext: item.billingPeriod | formatBillingPeriod : item.revenuePeriod
    }"
    [showItemId]="false"
    [showEditionName]="false"
  />
  <ng-container *ngIf="showPricing">
    <div>
      <div class="item-pricing">
        <billing-ui-simple-price-display
          [price]="(item.pricing.totalPriceInDollars || 0) * 100"
          [currencyCode]="item.pricing.currency"
          [frequency]="Frequency.ONE_TIME"
        />
      </div>
      <div
        class="store-price"
        *ngIf="
          item.pricing.totalStorePriceInDollars &&
          item.pricing.totalStorePriceInDollars > item.pricing.totalPriceInDollars
        "
      >
        <billing-ui-simple-price-display
          [price]="(item.pricing.totalStorePriceInDollars || 0) * 100"
          [currencyCode]="item.pricing.currency"
          [frequency]="Frequency.ONE_TIME"
        />
      </div>
    </div>
  </ng-container>
</div>
